import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { doLogin } from '../../services/AuthService';
import { setToken } from '../../services/TokenStorage';
// import { processError } from '../../services/ServiceUtils';
import ActionMessage from '../../components/ActionMessage/ActionMessage';
import { setEnvironment } from '../../services/EnvironmentStorage';
import { getPathHomePage } from '../../utils/HomePageUtils';

function Login() {
    const history = useHistory();
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const params = new URLSearchParams(location.search);
    const expired = params.get('expired') === '1';
    const revoked = params.get('revoked') === '1';

    function onChangeInput(event) {
        if (event.target.id === "email")
            setEmail(event.target.value);
        else if (event.target.id === "password")
            setPassword(event.target.value);
    }

    function onSubmit(event) {
        event.preventDefault();

        doLogin(email, password)
            .then(response => {
                if (response) {
                    setToken(response.token);
                    setEnvironment(response.environment);
                    history.push(getPathHomePage());
                }
            })
            .catch(err => {
                console.log(err);
                // processError(err);
                setError(`Usuário e/ou senha inválidos!`);
            })
    }

    return (
        <main>
            <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
                <div className="container">
                    <p className="text-center d-none">
                        <Link to="/" className="d-flex align-items-center justify-content-center">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd"></path>
                            </svg>
                            Voltar para a página inicial
                        </Link>
                    </p>
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        <div className="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                            <div className="text-center">
                                <img src="/img/favicon/mstile-150x150.png" alt="Hydra" with={64} />
                            </div>
                            <div className="text-center text-md-center mb-4 mt-md-0">
                                <h1 className="mb-0 h3">Acesse a plataforma</h1>
                            </div>
                            {revoked && (
                                <div className="alert alert-danger py-2 text-center" style={{ fontSize: 13 }}>
                                    Sua sessão foi encerrada pelo administrador.
                                </div>
                            )}
                            {expired && !revoked && (
                                <div className='alert alert-warning py-2 text-center' style={{ fontSize: 13 }}>
                                    Sua sessão expirou. Faça login novamente para continuar.
                                </div>
                            )}
                            <form action="#" className="mt-4" onSubmit={onSubmit}>
                                <div className="form-group mb-4">
                                    <label htmlFor="email">Seu E-mail</label>
                                    <div className="input-group">
                                        <span className="input-group-text" id="basic-addon1">
                                            <svg className="icon icon-xs text-gray-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                                        </span>
                                        <input type="email" className="form-control" placeholder="exemplo@empresa.com" id="email" autoFocus required onChange={onChangeInput} />
                                    </div>
                                </div>
                                <div className="form-group mb-4">
                                    <label htmlFor="password">Sua Senha</label>
                                    <div className="input-group">
                                        <span className="input-group-text" id="basic-addon2">
                                            <svg className="icon icon-xs text-gray-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"></path></svg>
                                        </span>
                                        <input type="password" placeholder="Senha" className="form-control" id="password" required onChange={onChangeInput} />
                                    </div>
                                </div>
                                {/* <div className="d-flex justify-content-between align-items-top mb-4"> */}
                                <div className="d-none justify-content-between align-items-top mb-4">
                                <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="remember" />
                                        <label className="form-check-label mb-0" htmlFor="remember">
                                        Lembrar de mim
                                        </label>
                                    </div>
                                    <div><Link to="/forgot-password" className="small text-right">Esqueci a senha</Link></div>
                                </div>
                                <div className="d-grid">
                                    <button type="submit" className="btn btn-gray-800">Entrar</button>
                                </div>
                                <ActionMessage error={error} extraClassName="mt-2" />
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Login;